import { stringFieldSchema } from '@utils';

// The error message in this schema differs from the existing binaryOptionSchema
export const contactUserOptionsSchema = stringFieldSchema(
  'canWeContactYou',
  'Please select an option to proceed',
);
